export function isContain (rect, point) {
  if(!rect) return false
  if (point.x < rect.x1 || point.x > rect.x2 || point.y < rect.y1 || point.y > rect.y2) return false
  return true
}